import { SaveButton } from "../../components/SaveButton";

export const initializeTaxRates = () => {
    const SaveBtn = new SaveButton('#edit-tax-modal');

    $('body').off('click', '#edit-tax-modal #button-save-tax')
        .on('click', '#edit-tax-modal #button-save-tax', function(ev) {
            let data = {
                title: $('#edit-tax-modal .tax_rate_form input[name="title"]').val(),
                percent: $('#edit-tax-modal .tax_rate_form input[name="percent"]').val()
            };

            if ($(ev.target).attr('data-id')) {
                data.id = $(ev.target).attr('data-id');
            }

            $.ajax({
                type: 'POST',
                url: '/settings/business/create-edit-tax',
                data: data,
                beforeSend: () => {
                    SaveBtn.startLoading();
                },
                success: (response) => {
                    if (response?.success) {
                        SaveBtn.stopLoading().then(() => {
                            SaveBtn.showSuccess();
                        });

                        if (data.id) {
                            let el = $(`.tax_rates .create-edit-tax[data-id="${data.id}"]`);
                            if (el) {
                                el.parents('.tax-row').find('.title-tax').text(data.title);
                                el.attr('data-title', data.title);
                            }
                        } else if (response?.newId) {
                            let template = $(`.tax_rates #tax-row-tmpl`).clone(true);
                            template.attr('id', '');
                            template.removeClass('d-none');
                            template.find('.title-tax').text(data.title);
                            template.find('.percent').text(Number(data.percent).toFixed(2) + '%');
                            template.find('.create-edit-tax').attr('data-id', response.newId)
                                .attr('data-percent', data.percent)
                                .attr('data-title', data.title);
                            $('.tax_rates .tax_rates_list tbody').append(template);
                        }

                        setTimeout(() => $('#edit-tax-modal').modal('hide'), 3000);
                    } else {
                        $('#edit-tax-modal .component-data-save .error-message').html('');

                        if (typeof response.error == 'object') {
                            let errorsArr = Object.values(response.error);
                            $('#edit-tax-modal .component-data-save .error-message').append(errorsArr.join('<br>'));
                        } else if (typeof response.error == 'string') {
                            $('#edit-tax-modal .component-data-save .error-message').text(response.error);
                        }

                        SaveBtn.stopLoading().then(() => {
                            SaveBtn.showError();
                        });
                    }
                },
                error: () => {
                    SaveBtn.showError();
                }
            });
        });

    $('body').off('click', '.tax_rates .create-edit-tax')
        .on('click', '.tax_rates .create-edit-tax', function(ev) {
            if ($(ev.target).data('id')) {
                $('#edit-tax-modal .tax_rate_form input[name="title"]').val($(ev.target).data('title'));
                $('#edit-tax-modal .tax_rate_form input[name="percent"]').val($(ev.target).data('percent'));
                $('#edit-tax-modal .tax_rate_form input[name="percent"]').attr('disabled', true);
                $('#edit-tax-modal #button-save-tax').attr('data-id', $(ev.target).data('id'));
            } else {
                $('#edit-tax-modal .tax_rate_form input[name="percent"]').attr('disabled', false);
                $('#edit-tax-modal .tax_rate_form input[name="percent"]').val('');
                $('#edit-tax-modal .tax_rate_form input[name="title"]').val('');
                $('#edit-tax-modal #button-save-tax').attr('data-id', '');
            }

            $('#edit-tax-modal').modal('show');
        });

    $('body').off('input', '#edit-tax-modal .tax_rate_form input[name="percent"]')
        .on('input', '#edit-tax-modal .tax_rate_form input[name="percent"]', function(ev) {
            let value = $(ev.target).val();

            if (/[^0-9\.]*/.test(value)) {
                value = value.replace(/[^0-9\.]*/g, '');
            }

            if (value.toString().match(/[.]/g)?.length > 1 || /\.\d{3,}/.test(value)) {
                value = value.substring(0, value.length - 1);
            }

            if (Number(value) > 100 || /100\./.test(value)) {
                value = 100;
            }

            $(ev.target).val(value);
        });
};
